import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import useUpdateRateMultiplierMutation from 'components/domain/integrations/useUpdateRateMultiplierMutation';
import useModalId from 'components/modal/useModalId';
import useAppModal from 'hooks/useAppModal';
import useNotify from 'hooks/useNotify';
import { InternalIntegrationSetting } from 'models/InternalIntegrationSetting';
import { INTERNAL_INTEGRATION_SETTINGS_BASE_QUERY_KEY } from 'pages/channels/integrationSettingsQuery';
import { EditRateMultiplierFormValues } from './EditRateMultiplierModal.schema';

const useEditRateMultiplierModalFormSubmit = ({
  integrationSettings,
}: {
  integrationSettings: InternalIntegrationSetting;
}) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const modalId = useModalId();
  const { closeModal } = useAppModal();
  const { notifyError } = useNotify();
  const { mutateAsync: updateRateMultiplier } = useUpdateRateMultiplierMutation(
    {
      onError: () => {
        notifyError(t('common.somethingWentWrong'));
      },
    },
  );

  const onSubmit = async (data: EditRateMultiplierFormValues) => {
    const { rateMultiplier } = data;

    await updateRateMultiplier({
      enumId: integrationSettings?.enumId,
      rateMultiplier,
    });

    closeModal(modalId);

    queryClient.invalidateQueries([
      INTERNAL_INTEGRATION_SETTINGS_BASE_QUERY_KEY,
    ]);
  };

  return { onSubmit };
};

export default useEditRateMultiplierModalFormSubmit;
